// src/data/team.js
import smallImage1 from '../../../assets/images/small/img-1.jpg';
import smallImage2 from '../../../assets/images/small/img-2.jpg';
import smallImage3 from '../../../assets/images/small/img-3.jpg';
import smallImage4 from '../../../assets/images/small/img-4.jpg';
import smallImage5 from '../../../assets/images/small/img-5.jpg';
import smallImage6 from '../../../assets/images/small/img-6.jpg';
import smallImage7 from '../../../assets/images/small/img-7.jpg';
import smallImage8 from '../../../assets/images/small/img-8.jpg';
import smallImage9 from '../../../assets/images/small/img-9.jpg';
import smallImage10 from '../../../assets/images/small/img-10.jpg';
import smallImage11 from '../../../assets/images/small/img-11.jpg';
import smallImage12 from '../../../assets/images/small/img-12.jpg';

//User Images
import avatar1 from '../../../assets/images/users/avatar-1.jpg';
import avatar2 from '../../../assets/images/users/avatar-2.jpg';
import avatar3 from '../../../assets/images/users/avatar-3.jpg';
import avatar5 from '../../../assets/images/users/avatar-5.jpg';
import avatar4 from '../../../assets/images/users/avatar-4.jpg';
import avatar6 from '../../../assets/images/users/avatar-6.jpg';
import avatar7 from '../../../assets/images/users/avatar-7.jpg';
import avatar8 from '../../../assets/images/users/avatar-8.jpg';

const teamData = [
  {
    id: 1,
    backgroundImg: smallImage9,
    userImage: avatar2,
    name: "Nancy Martino",
    designation: "Team Leader & HR",
    projectCount: 225,
    taskCount: 197
  },
  {
    id: 2,
    backgroundImg: smallImage12,
    userImage: null,
    userShortName: "HB",
    name: "Henry Baird",
    designation: "Full Stack Developer",
    projectCount: 352,
    taskCount: 376,
    bgColor: "danger",
    textColor: "danger"
  },
  {
    id: 3,
    backgroundImg: smallImage11,
    userImage: avatar3,
    name: "Frank Hook",
    designation: "Project Manager",
    projectCount: 162,
    taskCount: 192
  },
  {
    id: 4,
    backgroundImg: smallImage1,
    userImage: avatar8,
    name: "Jennifer Carter",
    designation: "UI/UX Designer",
    projectCount: 241,
    taskCount: 205
  },
  {
    id: 5,
    backgroundImg: smallImage10,
    userImage: null,
    userShortName: "ME",
    name: "Megan Elmore",
    designation: "Team Leader & Web Developer",
    projectCount: 201,
    taskCount: 263,
    bgColor: "success",
    textColor: "success"
  },
  {
    id: 6,
    backgroundImg: smallImage2,
    userImage: avatar4,
    name: "Alexis Clarke",
    designation: "Backend Developer",
    projectCount: 132,
    taskCount: 147
  },
  {
    id: 7,
    backgroundImg: smallImage4,
    userImage: null,
    userShortName: "NC",
    name: "Nathan Cole",
    designation: "Front-End Developer",
    projectCount: 352,
    taskCount: 376,
    bgColor: "info",
    textColor: "info"
  },
  {
    id: 8,
    backgroundImg: smallImage7,
    userImage: avatar6,
    name: "Joseph Parker",
    designation: "Full Stack Developer",
    projectCount: 64,
    taskCount: 93
  },
  {
    id: 9,
    backgroundImg: smallImage3,
    userImage: avatar5,
    name: "Erica Kernan",
    designation: "Web Designer",
    projectCount: 345,
    taskCount: 298
  },
  {
    id: 10,
    backgroundImg: smallImage5,
    userImage: null,
    userShortName: "DP",
    name: "Donald Palmer",
    designation: "Wed Developer",
    projectCount: 95,
    taskCount: 135,
    bgColor: "light",
    textColor: "primary"
  },
  {
    id: 11,
    backgroundImg: smallImage8,
    userImage: avatar7,
    name: "Jack Gough",
    designation: "React Js Developer",
    projectCount: 87,
    taskCount: 121
  },
  {
    id: 12,
    backgroundImg: smallImage6,
    userImage: null,
    userShortName: "MW",
    name: "Marie Ward",
    designation: "Backend Developer",
    projectCount: 145,
    taskCount: 210,
    bgColor: "success",
    textColor: "success"
  }
];

export default teamData;
